import React from 'react'
import SignUpOrLogin from './SignUpOrLogin'
//import useLocale from 'js/hooks/useLocale'
import { FormattedMessage } from 'react-intl'

/*
const planScreens = {
  de: require('./assets/plan-screens-de.png'),
  en: require('./assets/plan-screens-en.png'),
  es: require('./assets/plan-screens-es.png'),
  it: require('./assets/plan-screens-it.png'),
  pt: require('./assets/plan-screens-pt.png'),
}
*/

type Props = {
  firstName: string
  onLoginClick: () => void
}

export default function GetStarted({ firstName, onLoginClick }: Props) {
  //const { language } = useLocale()

  return (
    <div className="flex w-full flex-col-reverse gap-10 lg:flex-row">
      {/*
      <div className="relative mb-16 lg:mt-32 lg:w-1/2">
        <img
          className="right-0 top-1/2 transform lg:absolute lg:max-h-full lg:max-w-none lg:-translate-y-1/2"
          src={planScreens[language] || planScreens.en}
          alt=""
        />
      </div>
      */}
      <div className="my-auto text-center lg:w-1/2 xl:px-64">
        <h1 className="type-med-fat text-Brand">
          <FormattedMessage
            id="gympass_welcome_heading"
            defaultMessage="Welcome, {firstName}"
            values={{ firstName }}
          >
            {([text]) => {
              if (!firstName && typeof text === 'string') {
                return <>{text.replace(',', '!')}</>
              }
              return <>{text}</>
            }}
          </FormattedMessage>
        </h1>
        <p className="mb-32 mt-20 leading-body lg:mb-48">
          <FormattedMessage
            id="gympass_intro"
            defaultMessage="As a Wellhub member, you are eligible for a free Lifesum Premium subscription. Get started here!"
          />
        </p>
        <SignUpOrLogin onLoginClick={onLoginClick} />
      </div>
    </div>
  )
}
